import{__require as r}from"../node_modules/focus-trap-react/dist/focus-trap-react.js";var a=r();export{a as f};
